import { Injectable } from '@angular/core';
import { ReportControllerService, ReportRequestDtoReportTypeEnum } from '@scip/api';
import { NotificationService } from './notification.service';
import { ReportRequestDto } from '@scip/api/model/report-request-dto';
import { catchError, delay, tap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { Store } from '@ngrx/store';
import { translationKeys } from '../core';
import { NotificationsActions } from '@avano/avano-components/avano-notifications';
import { LoadingInfo } from '@scip/api/model/loading-info';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  constructor(private reportControllerService: ReportControllerService, private notificationService: NotificationService, private store: Store) {}

  triggerReportCreation(reportType: ReportRequestDtoReportTypeEnum, loadingInfo: LoadingInfo): void {
    const request: ReportRequestDto = {
      reportType,
      searchInfo: loadingInfo
    };

    this.reportControllerService
      .requestReport(request)
      .pipe(
        tap(() => this.notificationService.showSuccess(translationKeys.reportService.typescript.notification.reportSuccess)),
        catchError(() => {
          this.notificationService.showError(translationKeys.reportService.typescript.notification.reportFailure);
          return EMPTY;
        }),
        delay(5000), // If the report is created really fast, we directly update the notification
        tap(() => this.store.dispatch(NotificationsActions.load()))
      )
      .subscribe();
  }
}
